// extracted by mini-css-extract-plugin
export default {"orbit":"style_orbit__Dt70S","sub_orbit":"style_sub_orbit__W34ua"};